import type { Component } from './types';

import { useState } from 'react';

import { InputGroup } from '@sgcmpteltd/uikit-react';

import { CustomInput } from '../input/component';
import { InputPasswordIcon } from './_component/icon';

import { cn } from '@/lib/utils';

export const InputPassword: Component = ({ inputGroupProps, inputProps }) => {
  const [show, setShow] = useState(false);
  const isDisabled = inputProps.disabled ?? false;

  return (
    <InputGroup
      className={cn(
        {
          '!bg-red-50': inputGroupProps.isInvalid,
          '!border-gray-400': !inputGroupProps.isInvalid,
        },
        inputGroupProps.className,
      )}
      {...(!isDisabled && {
        suffix: (
          <InputPasswordIcon
            onClick={() => setShow(prevState => !prevState)}
            show={show}
          />
        ),
      })}
      {...inputGroupProps}
    >
      <CustomInput
        {...inputProps}
        autoComplete="new-password"
        noBorder
        type={show ? 'text' : 'password'}
      />
    </InputGroup>
  );
};
